import "google-fonts";
import "regenerator-runtime/runtime";

import Bodycomponent from "./component/bodycomponent.js";


import React, { useRef, useState, useEffect } from "react";
import "./App.css";
import { db } from "./config/firebase";

import { getDoc, doc } from "firebase/firestore";

function App() {
  const [float_visible, setfloat_Visible] = useState(true);

  const [imageUrl, setImageUrl] = useState();
  const [title, setTitle] = useState();
  const [defualtMessages, setDefualtMessages] = useState([]);
  const [submenu,setSubmenu]=useState([]);
 
  const urlParams = new URLSearchParams(window.location.search);
  const currentDomain = urlParams.get("parentUrl");
  console.log("-----------------------------------------------", currentDomain, "--------------------------------------");
  const shopId = currentDomain || "null";

  
  useEffect(() => {
    const fetchImage = async () => {
      try {
        // Replace `collectionName` and `documentId` with your Firestore structure
        const docRef = doc(db, "Shopify", shopId);
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
          setImageUrl(docSnap.data().Avatar_Link || "https://firebasestorage.googleapis.com/v0/b/open-source-28ce5.appspot.com/o/whatsapp-media%2Fbot.png?alt=media&token=dee0144e-14ca-4e2d-99e8-ad03a6618559");
          setTitle(docSnap.data()?.Botname || "");
          const actionButtons=docSnap.data()?.ActionButtons ?? {}

          const submenu=docSnap.data()?.Submenu??[]
          console.log("this is submenu",submenu)

          // {"Suggest skin care routine for men!":"Suggest skin care routine for men!","Suggest some best concealer":"Suggest some best concealer", "Mujhe dark spots remove karne hain":"Mujhe dark spots remove karne hain"}
          // {"Want to explore our bestsellers ?":"Show me your bestsellers","Want to customise a trip ?":"I want a custom trip"};
          setDefualtMessages(actionButtons)
          setSubmenu(submenu)
          
          const all_colors = docSnap.data()?.Color_Theme || {};
          const headerbackground = all_colors.primaryColor ?? "#dcf2d9";
          const headertext = all_colors.textSecondaryColor ?? "#000000";
          const bubble_user = all_colors.secondaryColor ?? "#3b892e";
          const send_button = all_colors.buttonTextColor ?? "#000";
          const footercolor = all_colors.primaryColor ?? "#5c583b";
          const textcolor = all_colors.textPrimaryColor ?? "#000000";
          const primarycolor = all_colors.primaryColor ?? "#000000";
          const accentColor = all_colors.accentColor ?? "#3b892e";
          const bubble_Sender = all_colors.bubble_Sender ?? "#000";
    
          // const bubblecolor=all_colors.
      
          const wholesectionbackground = all_colors.backgroundColor ?? "#fff";

          document.documentElement.style.setProperty("--color-text", textcolor);
          document.documentElement.style.setProperty("--color-bubble", bubble_user);
          document.documentElement.style.setProperty("--color-header", headerbackground);
          document.documentElement.style.setProperty("--color-footer", footercolor);
          document.documentElement.style.setProperty("--color-headertext", headertext);
          document.documentElement.style.setProperty("--color-primary1", primarycolor);
          document.documentElement.style.setProperty("--color-buttontext", send_button);
          document.documentElement.style.setProperty("--color-buttonbackground", accentColor);
          document.documentElement.style.setProperty("--color-chatbackground", wholesectionbackground);
          document.documentElement.style.setProperty("--color-bubbletext", bubble_Sender);

        } else {
          console.log("No such document!");
        }
      } catch (error) {
        console.error("Error fetching image: ", error);
      }
    };

    fetchImage();
  }, []);

useEffect(() => {
  const handleMessage = (event) => {
    if (event.data.type === 'TOGGLE_CHAT_VISIBILITY') {
      setfloat_Visible(event.data.visible);
    }
  };

  window.addEventListener('message', handleMessage);
  
  return () => {
    window.removeEventListener('message', handleMessage);
  };
}, []);

// Send message to parent to control toggle button visibility
useEffect(() => {
  if (window.parent && window.parent !== window) {
    window.parent.postMessage({
      type: 'TOGGLE_CHAT_VISIBILITY',
      visible: !float_visible // Hide toggle button when chat IS visible
    }, '*');
  }
}, [float_visible]);




  return (
  <div
  style={{
    position: "absolute",
    top: 0,        // Changed from bottom: 0
    left: 0,
    right: 0,
    bottom: 0,     // Added to fill full height
    zIndex: 10,
    display: float_visible ? 'block' : 'none', // Control visibility
   
  }}
  className="krunk-bg-transparent"
>
  <div className="krunk-flex krunk-justify-end krunk-h-full krunk-bg-transparent">
    {float_visible && (
      <div className="krunk-flex krunk-flex-col krunk-h-full krunk-w-full krunk-max-w-md">
        <Bodycomponent
          float_visible={float_visible}
          setfloat_Visible={setfloat_Visible}
          imageurl={imageUrl}
          title={title}
          actionButtons={defualtMessages}
          subMenu={submenu}
          className="krunk-w-full krunk-h-full krunk-flex-1"
        />
      </div>
    )}
  </div>
</div>
  );
}

export default App;
